import type { Colors, DefaultTheme } from 'styled-components';
import { darkColors, mapDarkTheme } from './DarkTheme';

const colors: Colors = {
  ...darkColors,
  primary: {
    lighten: '#1774c5',
    default: '#125997',
    dim: 'rgba(18,89,151,0.4)',
    mute: 'rgba(18,89,151,0.1)',
  },
  gray: {
    '100': '#ffe',
    '000': '#040405',
    '010': '#0b0b0b',
    main: '#1a1c22',
    '020': '#27292e',
    '030': '#35373a',
    '040': '#434446',
    '050': '#4a4b4c',
    '060': '#535455',
    '070': '#636463',
    '080': '#8c8d88',
    '090': '#acada4',
  },
  green: {
    lighten: '#12e8a1',
    default: '#0eb980',
    dim: 'rgba(14,185,128,0.4)',
    mute: 'rgba(14,185,128,0.1)',
  },
  red: {
    lighten: '#c74454',
    default: '#a63240',
    dim: 'rgba(166,50,64,0.4)',
    mute: 'rgba(166,50,64,0.1)',
  },
  yellow: {
    lighten: '#efce62',
    default: '#eabf34',
    dim: 'rgba(234,191,52,0.4)',
    mute: 'rgba(234,191,52,0.1)',
  },
  orange: {
    lighten: '#ff6c1a',
    default: '#E65200',
    dim: 'rgba(230,82,0,0.4)',
    mute: 'rgba(230,82,0,0.1)',
  },
  blue: {
    lighten: '#61a8f0',
    default: '#338EEB',
    dim: 'rgba(51,142,235,0.4)',
    mute: 'rgba(51,142,235,0.1)',
  },
  purple: {
    lighten: '#a778e2',
    default: '#8B4ED9',
  },
  white: {
    default: '#ffffff',
    dim: 'rgba(255,255,255,0.4)',
    mute: 'rgba(255,255,255,0.1)',
  },
  black: {
    default: '#000000',
    dim: 'rgba(0,0,0,0.4)',
    mute: 'rgba(0,0,0,0.1)',
  },
};

export const DarkCelsionTheme: DefaultTheme = mapDarkTheme(colors, {
  name: 'DarkCl',

  backgroundChartUpColor: colors.green.lighten,
  backgroundChartDownColor: colors.red.lighten,
  borderColorChartUpColor: colors.green.lighten,
  borderColorChartDownColor: colors.red.lighten,

  colorTextDefaultButton: '#ffffff',
  colorTextDefaultButtonHover: '#ffffff',
  colorTextDefaultButtonFocus: '#ffffff',
  colorTextDefaultButtonActive: '#ffffff',
  colorTextDefaultButtonDisabled: 'rgba(255,255,255,0.5)',

  colorTextPositiveButton: '#000000',
  colorTextPositiveButtonHover: '#000000',
  colorTextPositiveButtonFocus: '#000000',
  colorTextPositiveButtonActive: '#000000',
  colorTextPositiveButtonDisabled: 'rgba(0,0,0,0.5)',

  colorTextWarningButton: '#000000',
  colorTextWarningButtonHover: '#000000',
  colorTextWarningButtonFocus: '#000000',
  colorTextWarningButtonActive: '#000000',
  colorTextWarningButtonDisabled: 'rgba(0,0,0,0.5)',

  colorTextMutedButton: '#ffffff',
  colorTextMutedButtonHover: '#ffffff',
  colorTextMutedButtonFocus: '#ffffff',
  colorTextMutedButtonActive: '#ffffff',
  colorTextMutedButtonDisabled: 'rgba(255,255,255,0.5)',
});
